export const DEFAULT_MAX_SELL_QUANTITY = 5
